import { render, staticRenderFns } from "./PendingVisitations.vue?vue&type=template&id=960c9b8a&"
import script from "./PendingVisitations.vue?vue&type=script&lang=js&"
export * from "./PendingVisitations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports